import styles from "./home.module.scss";
import * as React from "react";
import Header from "@components/Header";
import Hero from "@components/Hero";
import Pictures from "@components/Pictures";
import Sections from "@components/Sections";
import Photo from "@components/Photo";
import Footer from "@components/Footer";
import Website from "@components/Website";

type Props = {};

const Home = (props: Props) => {
  React.useEffect(() => {
    // GSDevTools.create();
  }, []);

  return (
    <div className={styles["home"]} data-scroll-section>
      <h1
        style={{
          position: "absolute",
          width: "1px",
          height: "1px",
          padding: 0,
          margin: "-1px",
          overflow: "hidden",
          clip: "rect(0, 0, 0, 0)",
          whiteSpace: "nowrap",
          border: 0,
        }}
      >
        Inawo wedding planning platform
      </h1>
      <Header />
      <Hero />
      <Pictures />
      <Sections />
      <Photo />
      <Website />
      <Footer vendorsPage={false} />
    </div>
  );
};

export default Home;
